import useScroll from '@hooks/useScroll';
import React, { FC } from 'react';
import { BooleanField, Datagrid, EditButton, Filter, FilterProps, List, ListProps, ShowButton, TextField, TextInput } from 'react-admin';
import { styles } from '@constants/styles';

const BlogsFilter = (props: Partial<FilterProps>) => {
    const scroll = useScroll();

    return (
        <div style={styles(scroll) as React.CSSProperties}>
            <Filter {...props}>
                <TextInput label="Поиск" source="name" alwaysOn />
            </Filter>
        </div>
    );
};

const BlogsList: FC<ListProps> = (props) => (
    <List
        {...props}
        filters={<BlogsFilter />}
    >
        <Datagrid>
            <TextField
                source='id'
            />

            <TextField
                source='name'
                label="Название"
            />

            <TextField
                source='categoryName'
                label="Название категории"
            />

            <TextField
                source="views"
                label="Количество просмотров"
            />

            <BooleanField
                source='isDeleted'
                label="Удален"
            />

            <ShowButton />

            <EditButton />
        </Datagrid>
    </List>
);

export default BlogsList;
